module.exports = __webpack_public_path__ + "b5e283cf7290c38671bee4e1a84ea5fd.pdf";